import { inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from, combineLatest, forkJoin, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { isLoggedIn, currentUser } from '../auth.selectors';
import { AppState} from '../../core.state';
import { map, skipWhile } from 'rxjs/operators';
import { IdentityService } from '../../identity/identity.service';
import { I18nService } from '../../i18n';

@Injectable()
export class RoleGuard  {
  private i18n = inject(I18nService);

  constructor(
    public router: Router,
    private store: Store<AppState>,
    private authService: IdentityService, ) {}

    canActivateChild(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {

      const expectedRoles = route.data.Roles;
      // If no roles are set on the route just allow it
      if (!expectedRoles) return true;

      return combineLatest([
          this.authService.isAuthenticated$,
          this.store.pipe(select(currentUser)),
        ]).pipe(
          skipWhile( ([loggedIn, user]) => (user == null)),
          map( ([loggedIn, user]) => 
              {
                  if ( loggedIn && !(expectedRoles.some(r => user.role == r )) ) {
                      this.router.navigate(['/error/403'], {queryParams: {desc: this.i18n.t('core.auth.guards.role_guard.you_are_not_authorized_to_access', 'You are not authorized to access this page.')}});
                      return false;
                  };
                  return true;
              }
          )
        );

  }

}